<!-- progress bar starts -->
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class= "background-style ">
<div class="progress">
  <div class="circle done"> <span class="label ">1</span>
    <p class="title-span-1">BPG</p>   
  </div> <span class="bar"><span class=" bar-done "></span></span>

  <div class="circle done"> <span class="label">2</span>
    <p class="title-span-2">Areas of Impact</p>  


    <!-- </div> <span class="bar active"></span> -->
  </div> <span class="bar"><span class=" bar-done "></span></span>

  <div class="circle done"> <span class="label">3</span>
    <p class="title-span-3">Skills/interests</p>

  </div>  <span class="bar"><span class=" bar-done "></span></span>

  <div class="circle done"> <span class="label">4</span>
    <p class="title-span-4">Leadership</p>


  </div>  <span class="bar"><span class=" bar-done "></span></span>

  <div class="circle done"> <span class="label">5</span>
    <p class="title-span-5">Demographics</p>

  </div>
</div>
<!-- progress bar ends -->

<!-- membership demographics starts -->
<div class="div container form-group">

  <div class="heading">
    Please provide information on demographics, this is optional information and will be used to understand the
    membership of each BPG affinity. Check all that apply
  </div>

  <div class="row  ">
    <div class="col-md-4 col-lg-4 " *ngFor="let demographics of demographicsList">

      <label class="font-family">
        <input type="checkbox" [checked]="demographics.checked" name="check" (change)="toggleCheckbox($event,demographics)" id ="check_{{demographics.demograhicId}}"><span class="label-text vertical-align checkbox-style"></span>
        <label class="bpg-name bold-text" for="check_{{demographics.demograhicId}}">{{demographics.demographicsName}}</label>
      </label>

    </div>
  
  
    </div>
    <div class="desclmair-style">
        <!-- <textarea rows="4" cols="50" readonly> -->
            The demographic information is optional and will be used by D&I for external diversity surveys that allow Toyota to benchmark our BPG progress compared to the  marketplace . This informational is confidential.<br/> (We understand that HR and Legal will need to get approval this language.)
            <!-- </textarea> -->
    </div>
  </div>
  <p class="top-space text-center bottom-class margin-bottom">
    
    
    <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button" routerLink='../leadership' (click)="redirectToBpg()">BACK</button>
    <span class="col-md-1"></span>
    <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button" routerLink='../preview' (click)="saveData()">PREVIEW</button>
    <button type="button" class="btn btn-link button-position font-family-button" routerLink='../preview'(click)="skipDemographics()"> Skip Form ></button>
  </p>

</div>
<!-- membership demographics ends -->